var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logos",class:_vm.getContainerClass,on:{"click":function($event){return _vm.goTo('/')}}},[(_vm.type=='inline')?_c('div',{},[_c('img',{attrs:{"src":require('@/assets/logo.png'),"alt":""}})]):_vm._e(),(_vm.type=='without-text')?_c('div',{},[_c('img',{attrs:{"src":require('@/assets/logoWithoutText.png'),"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }